// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatarlusd } from "../../../icons/mono/build/icon-statarlusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatarlusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatarlusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatarlusdIcon.displayName = 'StatarlusdIcon';
}

export default StatarlusdIcon;